module.exports = __webpack_public_path__ + "static/media/eye.863ee5c8.png";